import { render, staticRenderFns } from "./CourseMultiForm.vue?vue&type=template&id=7b9f3e19&scoped=true&"
import script from "./CourseMultiForm.vue?vue&type=script&lang=js&"
export * from "./CourseMultiForm.vue?vue&type=script&lang=js&"
import style0 from "./CourseMultiForm.vue?vue&type=style&index=0&id=7b9f3e19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9f3e19",
  null
  
)

export default component.exports